import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { NavStyleStates } from './types';

const styles = {
  root: css`
    position: relative;
    z-index: 2;
    padding: 14px 14px 14px 0;
    width: 100%;
  `,
  iframeRoot: css`
    margin-left: 64px;
  `,
  controlsContainer: ({ theme }) => css`
    height: 36px;
    padding: 4px 6px 4px 11px;
    gap: 20px;
    border-radius: 29px;
    background-color: ${theme.colors.neutral.variant[0]};
  `,
  divider: ({ theme }) => css`
    width: 1px;
    height: 100%;
    background-color: ${theme.colors.neutral.variant[20]};
  `,
  logoContainer: css`
    display: flex;
    flex-direction: column;
  `,
  buttons: css`
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 24px;
  `,
} satisfies Styles<NavStyleStates>;

export const useStyles = withStyles(styles);
